export default {"src":"/_next/static/media/samandehi.d5db333f.svg","height":233,"width":171,"blurWidth":0,"blurHeight":0};